import React, { createContext, useCallback, useContext, useState } from 'react';
import { FlashbarProps } from '@cloudscape-design/components/flashbar';

type NotificationType = 'success' | 'error';

interface NotificationContext {
  items: FlashbarProps.MessageDefinition[];
  addNotification: (type: NotificationType, content: string) => void;
}

const NotificationsContext = createContext<NotificationContext>({
  items: [],
  addNotification: () => {},
});

export const NotificationsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [items, setItems] = useState<FlashbarProps.MessageDefinition[]>([]);

  const addNotification = useCallback((type: NotificationType, content: string) => {
    const id = String(Date.now());
    const dismiss = () => setItems(prev => prev.filter(i => i.id !== id));
    setItems(prev => [
      ...prev,
      {
        id,
        type,
        dismissible: true,
        onDismiss: dismiss,
        content,
      },
    ]);
    setTimeout(dismiss, 5000);
  }, []);

  return (
    <NotificationsContext.Provider value={{ items, addNotification }}>
      {children}
    </NotificationsContext.Provider>
  );
};

export const useNotifications = () => useContext(NotificationsContext);
